import React, { useState, useEffect } from "react";
// import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import "./Design.css";
import logo from "./imges/logo.png"
import axios from "axios";

const Design = () => {
  const [refresh, setRefresh] = useState("");
  const [recipe, setRecipe] = useState('');
  const [data, setData] = useState([]);
  const [loder, setLoder] = useState(false);

  useEffect(() => {
    const fetching_Api = async () => {
      const url = await axios.get(
        `https://api.edamam.com/search?q=${data}&app_id=96fd6ae6&app_key=05223f79aada8a23510c81fb5853413d`
      );

      setRecipe(url.data.hits);
      setLoder(false);
    };
    fetching_Api();
  }, [data]);

  return <>
      <div className="container container-fluid">
        <div className="nav fixed-top">
          <div>

          <img
            src={logo}
            
            alt="error"
            className="logo"
            />
            
            </div>
          <input
            type="search"
            placeholder="SEARCH RECIPE"
            className="search"
            onChange={(e) => setRefresh(e.target.value)}
          />
          <input
            type="submit"
            className="submit"
            onClick={() => {
              setRecipe([]);
              setData(refresh);
              setLoder(true);
            }}
          />
        </div>

        <div className="card_section">
        <h1 className="text-center">The RecipeApp</h1> 
        </div>

         { loder ? (
          // <h1 className="text-center">loading</h1/>
          <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        ) : (
          <div className="card" style={{background:'transparent' , border:'none'}}>


            {!recipe ? (
              <h1>no recipe found</h1>
            ) : (
              recipe.map((items) => {
                return (
                  <>
                    <div className="card_main ">
                      <img    src={items.recipe.image}
                        alt={items.recipe.label}
                        className="card_img"
                      />

                      <p className="recipe_Name">{items.recipe.label}</p>
                      <button
                        className="ingredient_btn"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        Ingredients
                      </button>
                      <div
                        className="modal fade"
                        id="exampleModal"
                        tabIndex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog">
                          <div className="modal-content" style={{background:'#222'}}>
                            <div className="modal-header">
                              <h5
                                className="modal-title"
                                id="exampleModalLabel"
                              >
                                Reicpe-Ingredients
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body" style={{color:'black'}}>
                              <table className="table text-white" >
                                <thead>
                                  <tr>
                                    <th scope="col">Ingredients</th>
                                    <th scope="col">Waight</th>
                                  </tr>
                                </thead>

                                {items.recipe.ingredients.map((ingre) => {
                                  console.log({ingre});
                                  return <>
                                      <tbody>
                                        <tr>
                                          <td>{ingre.text}</td>
                                          <td>{ingre.weight}</td>
                                        </tr>
                                      </tbody>
                                    </>
                                  
                                })}

                                <td style={{ fontWeight: "670" }}>
                                  Total Weight:- {items.recipe.totalWeight}
                                </td>
                              </table>
                            </div>

                          </div>
                        </div>
                      </div>

                      <a
                        href={items.recipe.url}
                        target="_blank"
                        className="find_recipe_btn"
                        rel="noreferrer"
                      >
                        Full Recipe
                      </a>
                    </div>
                  </>
                );
              })
            )}
          </div>
        )}
        
<p className="d-flex fixed-bottom ">By - <a className=" text-decoration-none text-white"   href="https://www.instagram.com/ganpat__koli/"  id="hoverIcon">Ganpat Koli</a>   </p>

      </div>
    </>
  };

export default Design;
